var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DrieLuik"},[_c('Header'),_c('div',{staticClass:"paarseBalk",attrs:{"id":"paarseBalk1"}}),_c('Panorama'),_c('div',{staticClass:"paarseBalk",attrs:{"id":"paarseBalk2"}}),_c('Map'),_c('div',{staticClass:"paarseBalk",attrs:{"id":"paarseBalk3"}}),_c('Carrousel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }